import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, ContentText, AuthorText, Name, Title } from './Quote.style';

const Quote = ({ quote }) => (
  <Wrapper>
    <ContentText>
      <em>{quote.content}</em>
    </ContentText>
    <AuthorText>
      <Name>{quote.author.name}</Name>
      <Title>{quote.author.title}</Title>
    </AuthorText>
  </Wrapper>
);

Quote.propTypes = {
  quote: PropTypes.shape({}).isRequired,
};

export default Quote;



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/Quote/Quote.js